// libs
import React from "react";
import { Layout } from "antd";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
// constants
import CONSTANTS from "../constants";
import { LOCAL_STORAGE } from "../constants/localStorageConstants.js";
// components
import HeaderDashBoard from "../components/Dashboard/HeaderDashBoard/index.jsx";
import ContentDashBoard from "../components/Dashboard/ContentDashBoard/index.jsx";
import TrackingPageViews from "../components/TrackingPageViews/index.jsx";
// import UserFeedbacks from "../components/UserFeedbacks";
import LoadingPage from "../components/LoadingPage/index.jsx";
import { MenuSidebar } from "@dx-hrsol/ui-kit";
// actions
import { requestChangeBranch } from "../actions/authorities/token/requestionChangeBranch.js";
import { checkUserShiftTypes } from "../actions/userShiftTypes/check/checkUserShiftTypes.js";
import { getShiftTypes } from "../actions/shiftTypes/index.js";
import { requestApi } from "../actions/apiCommon";
import { requestGetAuthorities } from "../actions/authorities/token/requestGetAuthorities.js";
import { setCurrentBranch } from "../actions/user/branchSelected/setCurrentBranch.js";
import { GetQuota } from "../actions/quotaAction.js";
import { metaDataOrg } from "../actions/metaData/requestMetaDataOrg";
// others
import { getCurrentBranchJSON, getAllBranchNormalizeMode } from "../config.js";
import menuSider from "../dataSources/SiderBarMenu";

const { GET_ALL_USER_SHIFT_TYPES } = CONSTANTS.PRIVILEGE;

const { SELECTED_BRANCH } = LOCAL_STORAGE;

const { Header, Content } = Layout;

class DashboardLayoutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      SELECTED_BRANCH: getCurrentBranchJSON(),
      width: 0,
      height: 0,
      selectedKeys: ["dashboard-daily-analysis"],
      openKeys: ["dashboard"],
      isShowModalChangeBranch: false,
      visible: false,
      displayDrawer: false,
      version: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  closeDrawer = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      visible: false,
    });
  };

  showModalChangeBranch = () => {
    this.setState({
      isShowModalChangeBranch: true,
    });
  };

  cancelModalChangeBranch = () => {
    this.setState({
      isShowModalChangeBranch: false,
    });
  };

  submitModalChangeBranch = (values) => {
    localStorage.setItem(SELECTED_BRANCH, JSON.stringify(values));
    this.props.setCurrentBranch(values.code);
    this.setState({
      isShowModalChangeBranch: false,
    });
    window.location.reload();
  };

  componentDidMount() {
    // this.props.GetQuota({
    //   params: {
    //     orgCode: getOrgCode(window.location.hostname),
    //     serviceCode: "attendance",
    //   },
    // });
    const { location } = this.props;

    this.onChangeLocation(location);
    this.updateWindowDimensions();
    this.props.requestGetAuthorities();
    this.props.getNotificationNumber();

    window.addEventListener("resize", this.updateWindowDimensions);

    const { userAuthorities } = this.props;
    if (userAuthorities && userAuthorities.includes(GET_ALL_USER_SHIFT_TYPES)) {
      this.props.checkUserShiftTypes(this.props.history, this.props.t);
      this.props.getShiftTypes();
    } else {
      this.props.checkUserShiftTypes(this.props.history, this.props.t, true);
    }
    // Get version
    requestApi.requestMetaDataOrg({
      cbSuccess: (res) => this.handleSuccess(res),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.onChangeLocation(this.props.location);
    }
    if (this.props.branch.length !== 0) {
      const curBranch = JSON.parse(localStorage.getItem(SELECTED_BRANCH));
      const check = this.props.branch.filter(
        (item) => item.code === curBranch.code
      );
      if (check.length === 0) {
        // old branch
        localStorage.setItem(
          SELECTED_BRANCH,
          JSON.stringify(this.props.branch[0])
        );
        this.props.setCurrentBranch(this.props.branch[0].code);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    if (window.innerWidth < 1025) {
      this.setState({
        width: window.innerWidth,
        collapsed: true,
        openKeys: [],
        visible: false,
        displayDrawer: true,
      });
    } else {
      this.setState({
        width: window.innerWidth,
        collapsed: false,
        visible: false,
        displayDrawer: false,
      });
    }
  }

  handleSuccess = (res) => {
    this.setState({
      version: res.productVersion,
    });
    this.props.dispatchMetaOrg(res);
  };

  onChangeLocation = (location) => {
    switch (true) {
      case location.pathname.includes("/dashboard/daily-analysis"):
        this.setState({
          selectedKeys: ["dashboard-daily-analysis"],
          openKeys: ["dashboard"],
        });
        break;

      case location.pathname.includes("/dashboard/user-analysis"):
        this.setState({
          selectedKeys: ["dashboard-user-analysis"],
          openKeys: ["dashboard"],
        });
        break;
      case location.pathname.includes("/dashboard/statistic"):
        this.setState({
          selectedKeys: ["dashboard-statistic"],
          openKeys: ["dashboard"],
        });
        break;
      case location.pathname.includes("/time"):
        this.setState({ selectedKeys: ["time"], openKeys: [] });
        break;
      case location.pathname.includes("/calendar"):
        this.setState({ selectedKeys: ["calendar"], openKeys: [] });
        break;
      case location.pathname.includes("/profile/information"):
        this.setState({
          selectedKeys: ["profile-information"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/profile/change-password"):
        this.setState({
          selectedKeys: ["profile-change-password"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/profile/worked-shift"):
        this.setState({
          selectedKeys: ["profile-worked-shift"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/profile/leave-type"):
        this.setState({
          selectedKeys: ["profile-leave-type"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/profile/emergency-contact"):
        this.setState({
          selectedKeys: ["profile-emergency-contact"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/profile"):
        this.setState({
          selectedKeys: ["profile-information"],
          openKeys: ["profile"],
        });
        break;
      case location.pathname.includes("/setting/shifts"):
        this.setState({
          selectedKeys: ["setting-shifts"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting/branch"):
        this.setState({
          selectedKeys: ["setting-branch"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting/users"):
        this.setState({
          selectedKeys: ["setting-users"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting/user-branch"):
        this.setState({
          selectedKeys: ["setting-user-branch"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting/organization"):
        this.setState({
          selectedKeys: ["setting-organization"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting/job-type"):
        this.setState({
          selectedKeys: ["setting-job-type"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/setting"):
        this.setState({
          selectedKeys: ["setting-branch"],
          openKeys: ["setting"],
        });
        break;
      case location.pathname.includes("/team"):
        this.setState({ selectedKeys: ["team"], openKeys: [] });
        break;
      case location.pathname.includes("/daily-report/my-report"):
        this.setState({
          selectedKeys: ["my-report"],
          openKeys: ["daily-report"],
        });
        break;
      case location.pathname.includes("/daily-report/all-reports"):
        this.setState({
          selectedKeys: ["all-reports"],
          openKeys: ["daily-report"],
        });
        break;
      case location.pathname.includes("/dashboard"):
      case location.pathname.includes("/"):
        this.setState({ selectedKeys: ["time"], openKeys: [] });
        break;
      default:
        break;
    }
  };

  toggle = () => {
    const openKeys = this.state.selectedKeys[0].split("-")[0];
    if (this.state.collapsed) {
      this.setState({
        collapsed: !this.state.collapsed,
        visible: !this.state.visible,
        openKeys: [openKeys],
      });
    } else {
      this.setState({
        collapsed: !this.state.collapsed,
        visible: !this.state.visible,
        openKeys: [],
      });
    }
  };

  handleClick = (e) => {
    const { SELECTED_BRANCH } = this.state;
    if (SELECTED_BRANCH.code !== e) {
      localStorage.setItem(
        SELECTED_BRANCH,
        JSON.stringify(getAllBranchNormalizeMode()[e])
      );
      this.props.requestChangeBranch();
      this.props.setCurrentBranch(e);
      window.location.replace("/time");
    }
  };

  onOpenChange = (newOpenKeys) => {
    var { openKeys } = this.state;
    newOpenKeys = newOpenKeys.filter((k) => !openKeys.includes(k));
    this.setState({ openKeys: newOpenKeys });
  };

  render() {
    const {
      t,
      userAuthorities,
      history,
      cookies,
      logoutUser,
      avatarData,
      requestChangeBranch,
      isLoadingGetAuthorities,
      userDetailInformation,
    } = this.props;

    const className = `${
      window.location.pathname.split("/").reverse()[0]
    }-layout-wrapper`;

    return isLoadingGetAuthorities ? (
      <LoadingPage size="50px" />
    ) : (
      localStorage.getItem(SELECTED_BRANCH) && (
        <Layout className="app-layout-wrapper">
          <Header
            style={{
              background: "#fff",
              padding: 0,
              position: "sticky",
              top: 0,
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
            }}
          >
            <HeaderDashBoard
              t={t}
              history={history}
              cookies={cookies}
              logoutUser={logoutUser}
              avatarData={avatarData}
              requestionChangeBranch={requestChangeBranch}
              collapsed={this.state.collapsed}
              toggle={() => this.toggle()}
              userBasicInfo={userDetailInformation}
            />
          </Header>
          <Layout style={{ flexDirection: "row", overflow: "hidden" }}>
            <MenuSidebar
              dataRenter={menuSider({ t })}
              visible={this.state.visible}
              collapsed={this.state.collapsed}
              userAuthorities={userAuthorities}
              history={history}
              toggle={() => this.toggle()}
              closeDrawer={this.closeDrawer}
              openKeys={this.state.openKeys}
              selectedKeys={this.state.selectedKeys}
              onOpenChange={(values) => {
                setTimeout(this.onOpenChange(values));
              }}
              isDisplayDrawer={this.state.displayDrawer}
              version={this.state.version}
              titleHeaderDrawer="Attendance"
              iconHeaderDrawer={
                <img
                  src="/images/UserServicesSVG/AttendanceUserServices.svg"
                  alt="hrsol"
                  height="45"
                  width="45"
                />
              }
            />
            <Layout style={{ overflowY: "auto" }}>
              {/* <UserFeedbacks /> */}
              <Content className={className}>
                <ContentDashBoard props={this.props} state={this.state} />
              </Content>
            </Layout>
          </Layout>
          {this.props.userDetailInformation && <TrackingPageViews />}
        </Layout>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.branchReducer,
    ...state.basicProfileReducer,
    userAuthorities: state.branchReducer.authorities,
    quota: state.Quota.quota,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // dispatching actions returned by action creators
    requestGetAuthorities: () => dispatch(requestGetAuthorities()),
    requestChangeBranch: () => dispatch(requestChangeBranch()),
    getShiftTypes: () => dispatch(getShiftTypes()),
    checkUserShiftTypes: () => dispatch(checkUserShiftTypes()),
    setCurrentBranch: () => dispatch(setCurrentBranch()),
    getNotificationNumber: () => dispatch(requestApi.getNotificationNumber()),
    GetQuota: () => dispatch(GetQuota()),
    dispatchMetaOrg: (res) => dispatch(metaDataOrg(res.groups)),
  };
};

export default withCookies(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation("dashboard")(DashboardLayoutContainer))
);
